export const setTokenValue = (token) => {
  localStorage.setItem(process.env.REACT_APP_TOKEN_KEY, token);
};

export const getTokenValue = () => localStorage.getItem(process.env.REACT_APP_TOKEN_KEY);

export const removeTokenValue = () => {
  localStorage.removeItem(process.env.REACT_APP_TOKEN_KEY);
};

export const decodeJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    Buffer.from(base64, 'base64')
      .toString('utf8')
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
};
